import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Volunteer } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';


export function getColumns(util: UtilityService, domainData: DomainDataService, app: AppService) {
	console.log(domainData.data().accApplicationStatusesMap)
	const columns: GridColumn<Volunteer, unknown>[] = [
		buildColumn(util, 'Id', row => row.assignedToStaffId, { header: 'assignedToStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.assignedToStaffId), { header: 'Assigned Staff', width: 15 }),
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 15 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 10 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastAutoEmailDeliveredUTC), { header: 'Last Auto Email Date', width: 10, hidden: true }),
		buildColumn(util, 'Id', row => row.volunteerId),
		buildColumn(util, 'FullName', row => row.person.fullName, { header: 'Name', width: 20 }),
		buildColumn(util, 'Text', row => domainData.data().volunteerStatusesMap[row.volunteerStatusId]?.name, { header: 'Status', width: 10 }),
		buildColumn(util, 'YesNo', row => row.isMentorApproved, { header: 'Mentor Approved', width: 10 }),
		buildColumn(util, 'YesNo', row => row.isInClassApproved, { header: 'In Class Approved', width: 10 }),
		buildColumn(util, 'YesNo', row => row.isOfficeHoursApproved, { header: 'Office Hours Approved', width: 10 }),
		buildColumn(util, 'YesNo', row => row.canVolunteerInEnglish, { header: 'English Approved', width: 10 }),
		buildColumn(util, 'YesNo', row => row.canVolunteerInSpanish, { header: 'Spanish Approved', width: 10 }),
		buildColumn(util, 'YesNo', row => row.hasLead, { header: 'Questionnaire Complete', width: 10 }),
		buildColumn(util, 'Text', row => row.agreementsSigned, { header: 'Agreements', width: 10, hidden: true }),
		buildColumn(util, 'YesNo', row => row.attendedOrientation, { header: 'Attended Orientation', width: 10, hidden: true }),
		buildColumn(util, 'YesNo', row => !!row.interviewDateUTC, { header: 'Interviewed', width: 10, hidden: true }),
		buildColumn(util, 'Text', row => row.hasEnVideo ? 'Added' : 'Missing', { header: 'English Video', width: 10, hidden: true }),
		buildColumn(util, 'Text', row => row.hasEsVideo ? 'Added' : 'Missing', { header: 'Spanish Video', width: 10, hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated Date', hidden: true }),
		buildColumn(util, 'Percent', row => row.interviewScore, { header: 'Interview Score', width: 30, hidden: true }),
		buildColumn(util, 'Text',
			row => row.questionnaireLearnId ? domainData.data().questionnaireLearnMap[row.questionnaireLearnId]?.name : undefined,
			{ header: 'Channel', headerTooltip: 'Questionnaire result: How did you learn about EforAll?', width: 80, hidden: true }
		),
	];

	return columns;

}
